import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Handles the Android hardware back button inside Capacitor.
 * Uses the global Capacitor object to avoid importing @capacitor/app
 * (which breaks the web dev build when types aren't installed).
 * Safely no-ops in a regular browser.
 */
export function useBackButton() {
  const navigate = useNavigate();

  useEffect(() => {
    const cap = (window as any).Capacitor;
    if (!cap?.isNativePlatform?.()) return;

    const plugins = cap.Plugins;
    if (!plugins?.App) return;

    const appPlugin = plugins.App;

    const handler = ({ canGoBack }: { canGoBack: boolean }) => {
      if (canGoBack) {
        navigate(-1);
      } else {
        appPlugin.minimizeApp();
      }
    };

    appPlugin.addListener('backButton', handler);

    return () => {
      appPlugin.removeAllListeners();
    };
  }, [navigate]);
}
